// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8DoeOgXSpFEaCURvoT5ncw\\=\\={display:flex;justify-content:space-between}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardMapSettings/DashboardMapSettings.module.scss"],"names":[],"mappings":"AAAA,6BACI,YAAA,CACA,6BAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DashboardMapSettingsToggler": "_8DoeOgXSpFEaCURvoT5ncw=="
};
export default ___CSS_LOADER_EXPORT___;
